import { format } from "date-fns"
import { CartOrder } from "../Cart/cartTypes"
import { roundTo2Decimal } from "../utils/utils"

export function generateOrderId(
    dbId: string | undefined,
    placedTs: string | undefined
): string {
    //NOTE same function is used in orderCreate, so the changes should be sincronized
    const id = dbId ?? "xxxx"
    const ts = placedTs ? new Date(placedTs) : new Date()
    // format(date, "Y-MM-dd HH:mm")
    return `${format(ts, "MMdd")}-${id[0]}${id[1]}${id[id.length - 2]}${
        id[id.length - 1]
    }`
}

export function sumOrderValue(cart: CartOrder["cart"]): number {
    return roundTo2Decimal(
        Object.keys(cart).reduce(
            (prevValue, currentElement) =>
                cart[currentElement].calculatedPrice + prevValue,
            0
        )
    )
}
